import React from 'react';
import axios from 'axios';
import _ from 'lodash';

function hasCommonItem(a, b)
{
  for(let i=0; i<a.length; ++i) {
    for(let j=0; j<b.length; ++j) {
      if(a[i] === b[j])
        return true;
    }
  }
  return false;
}

export default class CommProcess extends React.Component {

  base = {
    optionsEMMethod: undefined,
    optionsComponentType: undefined,
    optionsOrganism: undefined,
    optionsAuthor: undefined,
    optionsAuthorFull: undefined,
    optionsTeam: undefined,
    optionsEMDBStatus: undefined,
    optionsPublication: undefined,
    overviewEMDs: {
      debug: true,
      resMin: 0.77,
      resMax: 138.9,
      timeMin: new Date(2002, 5, 20),
      timeMax: new Date,
      gridMin: 1000,
      gridMax: 16240345088,
      dim0Min: 10,
      dim1Max: 5000,
    },
    itemsName: undefined,
    itemsEMMethod: undefined,
    itemsComponentType: undefined,
    itemsOrganism: undefined,
    itemsAuthor: undefined,
    itemsAuthorFull: undefined,
    itemsTeam: undefined,
    itemsEMDBStatus: undefined,
    itemsPapers: undefined,
    itemsPublication: undefined,
    itemsResolution: undefined,
    itemsReleaseDate: undefined,
    itemsGridCount: undefined,
    distanceMapAuthor: undefined,
    distanceMapRelease: undefined,
    distanceMapResolution: undefined,
    distanceMapOrganism: undefined,
    distanceMapPublication: undefined,
    distanceWeights: undefined,

    listEMMethod: undefined,
    listComponentType: undefined,
    listOrganism: undefined,
    listAuthor: undefined,
    listAuthorFull: undefined,
    listTeam: undefined,
    listEMDBStatus: undefined,
    listPapers: undefined,
    listPublication: undefined,

    linksTeam: undefined,

    dataListEMDs: [],
    levels: [],
    teamTree: [],
  };

  requestBaseData() {
    let promiseMeth = axios.get("/methods.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listEMMethod = res.data;
      this.base.optionsEMMethod = res.data.map((d, index) => ({value: index, label: d.name}));
      this.checkCompletion();
    });
    let promiseComp = axios.get("/components.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listComponentType = res.data;
      this.base.optionsComponentType = res.data.map((d, index) => ({value: index, label: d.name}));
      this.checkCompletion();
    });
    let promiseOrga = axios.get("/organisms.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listOrganism = res.data;
      this.base.optionsOrganism = res.data.map((d, index) => ({value: index, label: d.name + '(' + d.id + ')'}));
      this.checkCompletion();
    });
    let promiseAuth = axios.get("/authors.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listAuthor = res.data;
      this.base.optionsAuthor = res.data.map((d, index) => ({value: index, label: d.name}));
    })
    let promiseAufu = axios.get("/authors_f.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listAuthorFull = res.data;
      this.base.listAuthorFull.forEach(f => f.leading = -1)
      this.base.optionsAuthorFull = res.data.map((d, index) => ({value: index, label: d.name}));
    })
    let promiseStat = axios.get("/statuses.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listEMDBStatus = res.data;
      this.base.optionsEMDBStatus = res.data.map((d, index) => ({value: index, label: d.name}));
      this.checkCompletion();
    });
    let promisePapr = axios.get("/papers.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listPapers = res.data;
      this.base.optionsPaper = res.data.map((d, index) => ({value: index, label: d.title}));
      this.checkCompletion();
    });
    let promisePubl = axios.get("/publications.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listPublication = res.data;
      this.base.optionsPublication = res.data.map((d, index) => ({value: index, label: d.name}));
      this.checkCompletion();
    });
    let promiseOver = axios.get("/overview.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.overviewEMDs = res.data;
      this.checkCompletion();
    });
    let promiseNameL = axios.get("/item_names.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsName = res.data;
      this.checkCompletion();
    });
    let promiseMethL = axios.get("/item_methods.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsEMMethod = res.data;
      this.checkCompletion();
    });
    let promiseCompL = axios.get("/item_components.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsComponentType = res.data;
      this.checkCompletion();
    });
    let promiseOrgaL = axios.get("/item_organisms.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsOrganism = res.data;
      this.checkCompletion();
    });
    let promiseAuthL = axios.get("/item_authors.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsAuthor = res.data;
      this.checkCompletion();
    });
    let promiseAufuL = axios.get("/item_authors_f.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsAuthorFull = res.data;
      this.checkCompletion();
    });
    let promiseTeamL = axios.get("/item_teams.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsTeam = res.data;
      this.checkCompletion();
    });
    let promiseStatL = axios.get("/item_statuses.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsEMDBStatus = res.data;
      this.checkCompletion();
    });
    let promisePaprL = axios.get("/item_papers.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsPaper = res.data;
      this.checkCompletion();
    });
    let promisePublL = axios.get("/item_publications.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsPublication = res.data;
      this.checkCompletion();
    });
    let promiseResoL = axios.get("/item_resolutions.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsResolution = res.data;
      this.checkCompletion();
    });
    let promiseDateL = axios.get("/item_release_dates.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsReleaseDate = res.data.map(t => new Date(t));
      this.checkCompletion();
    });
    let promiseGridL = axios.get("/item_grid_counts.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.itemsGridCount = res.data;
      this.checkCompletion();
    });
    Promise.all([promiseAufu, promiseNameL, promiseDateL]).then(() => axios.get("/teams.json").then(res => {
      if(res.status !== 200)
        return;
      this.base.listTeam = res.data;
      this.base.listTeam.forEach((t, tidx) => {
        t.name = this.base.listAuthorFull[t.team[0]].name;
        this.base.listAuthorFull[t.team[0]].leading = tidx;
        let debutId = t.work.reduce((a, b) => this.base.itemsReleaseDate[a] <= this.base.itemsReleaseDate[b] ? a : b);
        t.debut = {
          id: debutId,
          date: this.base.itemsReleaseDate[debutId],
          name: this.base.itemsName[debutId],
        };
        t.level = 0;
      })
      this.base.optionsTeam = this.base.listTeam.map((d, index) => ({value: index, label: d.name}));
      this.base.linksTeam = this.base.listTeam.map((t, ti) =>
        this.base.listTeam.map((t1, t1i) =>
          (ti === t1i) ? undefined
            : (t.debut.date < t1.debut.date && t.team.indexOf(t1.team[0]) >= 0)
              ? {source: ti, target: t1i}
              : (t1.debut.date < t.debut.date && t1.team.indexOf(t.team[0]) >= 0)
                ? {source: t1i, target: ti}
                : undefined
        ).filter(link => link))
        .reduce((a,b) => a.concat(b));
      this.base.linksTeam.forEach(link => {
        this.base.listTeam[link.target].level = -1;
      })
      for(let cur_level = 0, modified = 1; modified > 0; ++cur_level) {
        modified = 0;
        this.base.linksTeam.forEach(link => {
          if(this.base.listTeam[link.source].level === cur_level && 
            this.base.listTeam[link.target].level < 0) {
            this.base.listTeam[link.target].level = cur_level + 1;
            ++modified;
          }
        })
      }
      this.base.linksTeam = this.base.linksTeam.filter(link => this.base.listTeam[link.target].level === this.base.listTeam[link.source].level + 1)
      this.base.linksTeam.forEach(link => {
        if(this.base.listTeam[link.source].children)
          this.base.listTeam[link.source].children.push(link.target);
        else
          this.base.listTeam[link.source].children = [link.target];
        if(this.base.listTeam[link.target].parents)
          this.base.listTeam[link.target].parents.push(link.source);
        else
          this.base.listTeam[link.target].parents = [link.source];
      })
      this.base.listTeam.forEach(t => {
        if(t.children)
          t.children = t.children.filter((ci, index) => t.children.indexOf(ci) === index)
        if(t.parents)
          t.parents = t.parents.filter((ci, index) => t.parents.indexOf(ci) === index)
      })
      let buildTeamTree = (t, tidx) => (t.children ? {
        name: t.name,
        id: tidx,
        children: t.children.map(c => buildTeamTree.bind(this)(this.base.listTeam[c], c)),
      } : {
        name: t.name,
        id: tidx,
      })
      this.base.teamTree = this.base.listTeam.map((t, tidx) => ({index: tidx, level: t.level}))
        .filter(t => t.level === 0)
        .map(t => buildTeamTree.bind(this)(this.base.listTeam[t.index], t.index));
      let setTreeId = (node, tidx) => {
        this.base.listTeam[node.id].treeId = tidx;
        node.children && node.children.forEach(c => setTreeId.bind(this)(c, tidx));
      }
      this.base.teamTree.forEach((tree, tidx) => setTreeId.bind(this)(tree, tidx))
      this.checkCompletion();
    }));
  }

  generateEMDDataList() {
    let {
      itemsName,
      itemsEMMethod,
      itemsComponentType,
      itemsOrganism,
      itemsAuthor,
      itemsAuthorFull,
      itemsTeam,
      itemsEMDBStatus,
      itemsPaper,
      itemsPublication,
      itemsResolution,
      itemsReleaseDate,
      itemsGridCount,
    } = this.base;
    if(itemsEMMethod && itemsComponentType && itemsOrganism && itemsAuthor && itemsTeam &&
      itemsEMDBStatus && itemsPaper && itemsPublication && itemsResolution && itemsReleaseDate &&
      itemsGridCount && itemsName && itemsAuthorFull) {
      this.base.dataListEMDs = itemsEMMethod.map((a, index) => ({
        n: itemsName[index],
        m: itemsEMMethod[index],
        c: itemsComponentType[index],
        o: itemsOrganism[index],
        a: itemsAuthor[index],
        f: itemsAuthorFull[index],
        u: itemsTeam[index],
        s: itemsEMDBStatus[index],
        d: itemsPaper[index],
        p: itemsPublication[index],
        r: itemsResolution[index],
        t: itemsReleaseDate[index],
        g: itemsGridCount[index],
      }))
    }
  }

  computeRankingLevelValues_TeamWork(list, levelCount) {
    let values = list.map(i => i.work.length);
    let total = _.reduce(values, (flattened, other) => flattened + other);
    let levels = [], cumulation = 0;
    for(let i=0, l=0; i<values.length; ++i) {
      let target = total * l / (levelCount - 1);
      cumulation += values[i];
      while(cumulation >= target) {
        levels.push(i);
        l++;
        target = total * l / (levelCount - 1);
      }
    }
    return levels.slice(0, levelCount);
  }

  computeRankingLevelValues(list, levelCount) {
    let values = list.map(i => i.count);
    //let total = _.reduce(values, (flattened, other) => flattened + other);
    let total = values.reduce((a,b) => a+b);
    let levels = [], cumulation = 0;
    for(let i=0, l=0; i<values.length; ++i) {
      let target = total * l / (levelCount - 1);
      cumulation += values[i];
      while(cumulation >= target) {
        levels.push(i);
        l++;
        target = total * l / (levelCount - 1);
      }
    }
    while(levels.length < levelCount)
      levels.push(values.length-1);
    return levels.slice(0, levelCount);
  }

  computeCompLevelValues(values, levelCount, inverse) {
    inverse ? values.sort((a,b) => b-a) : values.sort((a,b) => a-b);
    let levels = [];
    for(let l=0; l<levelCount; ++l) {
      let index = Math.floor((values.length - 1) * l / (levelCount - 1));
      levels.push(values[index]);
    }
    return levels;
  }

  computeLevelValues() {
    const levelCount = 9; // for ticks setting, levelCount should be n*4+1
    // [u, p, d, o, r, g]
    let {
      listOrganism,
      listTeam,
      listPapers,
      listPublication,
      itemsResolution,
      itemsGridCount,
      dataListEMDs
    } = this.base;
    let {
    } = this.base;
    this.base.levels.push(this.computeRankingLevelValues_TeamWork(listTeam, levelCount));
    this.base.levels.push(this.computeRankingLevelValues(listPublication, levelCount));
    this.base.levels.push(this.computeRankingLevelValues(listPapers, levelCount));
    this.base.levels.push(this.computeRankingLevelValues(listOrganism, levelCount));
    this.base.levels.push(this.computeCompLevelValues(itemsResolution.filter(r => r), levelCount));
    this.base.levels.push(this.computeCompLevelValues(itemsGridCount.map(g => +g[0]), levelCount, true));
  }
}
